module.exports = __webpack_public_path__ + "static/media/logo-2.09f67dd3.png";